import { createSlice } from "@reduxjs/toolkit";
import {
  fetchWarehousesList,
  createOrUpdateWarehouse,
  deleteWarehouse,
} from "./warehousesThunks";

const warehousesSlice = createSlice({
  name: "warehouses",
  initialState: {
    warehouses: [],
    loading: false,
    error: null,
    successMessage: null,
    selectedWarehouse: null,
    isEditWarehouse: false,
  },
  reducers: {
    resetWarehouseStatus: (state) => {
      state.successMessage = null;
    },
    setSelectedWarehouse: (state, action) => {
      state.selectedWarehouse = action.payload;
    },
    setIsEditWarehouse: (state, action) => {
      state.isEditWarehouse = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWarehousesList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchWarehousesList.fulfilled, (state, action) => {
        state.loading = false;
        state.warehouses = action.payload;
      })
      .addCase(fetchWarehousesList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createOrUpdateWarehouse.fulfilled, (state, action) => {
        state.successMessage = action.payload.message;
      })
      .addCase(deleteWarehouse.fulfilled, (state, action) => {
        state.successMessage = action.payload.message;
      });
  },
});

export const {
  resetWarehouseStatus,
  setSelectedWarehouse,
  setIsEditWarehouse,
} = warehousesSlice.actions;

export default warehousesSlice.reducer;
